import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { PhoneNumber } from "@grandvisionhq/forms";
/* empty css                                                                                              */
const Mbway = ({ initialValue, labels, onChange, validations }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "mbway-payment checkout-payment-wrapper" }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { className: "mbway-payment__info" }, labels.info), /* @__PURE__ */ React.createElement(
    PhoneNumber,
    {
      initialState: { value: initialValue, isTouched: false },
      required: true,
      onChange,
      validations,
      label: labels.phoneNumberLabel,
      placeholder: labels.phoneNumberPlaceholder,
      errorMessage: labels.phoneNumberError
    }
  )));
};
export {
  Mbway
};
//# sourceMappingURL=Mbway.js.map
